import { useFlags } from 'launchdarkly-react-client-sdk';
import { Banner } from './Banner';

export const EmergencyFrontendBanner = ({ classes = '' }) => {
  const { emergencyFrontendBannerWithMessage } = useFlags();

  if (!emergencyFrontendBannerWithMessage) {
    return null;
  }

  return (
    <div className={`bg-red-500 left-0 right-0 ${classes}`}>
      <Banner
        id='emergency'
        hideDismiss={true}
        type='warning'
        message={emergencyFrontendBannerWithMessage}
      />
    </div>
  );
};
